<template>
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top pt-3">
    <div class="container-xl align-items-center align-items-center">
        <a class="navbar-brand" style="z-index: 2" href="/">
            <img src="/img/LOGO.png" width="70px">
        </a>
        <button v-if="!$root.isCardDesc"
        @click.stop="openMenu"
        ref="buttonCollapse"
        class="hamburger border-0 position-relative" style="z-index: 2" type="button" data-target="#navbarCollapse" aria-controls="navbarCollapse"
        aria-expanded="false" aria-label="Toggle navigation">
            <span class="hamburger-container position-relative" tabindex="-1">
                <span class="hamburger-bars position-absolute"></span>
            </span>
        </button>

        <button v-if="$root.isCardDesc" style="z-index: 2" type="button" @click="$root.showDescrpition = !$root.showDescrpition" class="close big text-white" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <div v-else class="collapse navbar-collapse text-center" id="navbarCollapse" ref="navbarCollapse">
            <ul class="navbar-nav ml-auto align-items-center">
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/#tarot">Strona główna</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/tarot">Tarot</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/energy">Energie</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/numerology">Numerologia</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/workshops">Warsztaty</router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-primary" href="https://blog.strefatrzy.pl/">Blog</a>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/#about">O Nas</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link text-primary" to="/#contact">Kontakt</router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-primary" href="https://sklep.strefatrzy.pl/">Sklep</a>
                </li>
                <li class="nav-item" v-if="admin === 1">
                    <a class="nav-link text-primary" href="/home/cards-tarot">ADMIN</a>
                </li>
            </ul>
        </div>
    </div>
    <transition
        @before-enter="beforeEnter"
        @enter="slide"
        @leave="slide"
        :css="false">
        <div v-if="open" class="bg-collapse"></div>
    </transition>
    </nav>
</template>

<script>
    export default {
        props: ['admin'],
        data(){
            return {
                open: false,
            }
        },
        mounted(){
            let _this = this;
            $(window).on('resize', function(){
                _this.sizeWidth($(this).width())
            })
        },
        methods: {
            openMenu(){
                let _this = this;
                let id = $(_this.$refs.buttonCollapse).data('target');

                $(_this.$refs.buttonCollapse).toggleClass('active');
                this.open = !this.open;
                $(id).toggleClass('fixed').slideToggle(function(){

                    if(_this.open) $('html').css('overflow', 'hidden');
                    else $('html').css('overflow', '');
                })
            },
            closeNavbar(){
                if(this.open)
                {
                    $(this.$refs.navbarCollapse).slideToggle();
                    this.open = !this.open;
                }
            },
            beforeEnter(el){
                $(el).css('display', 'none');
            },
            slide(el, done){
                $(el).slideToggle(function(){
                    done();
                });
            },
            sizeWidth(width){
                if(width > 991.98 && this.open == true)
                {
                    this.openMenu();
                }
            },
        },
        watch: {
            '$route': function (el) {
                if($(this.$refs.buttonCollapse).hasClass('active'))
                {
                    this.openMenu();
                }
            }
        },
    }
</script>
